import { Button, Col, Row, Space, Tooltip } from 'antd'
import {
  RequestForInformation,
  useRFITrackerContext,
} from '../../../../../../RFITrackerContext'
import { CIMSTag } from '../../../../../../../../../../../../../components/CIMSTag'
import CIMSCheckbox from '../../../../../../../../../../../../../components/CIMSCheckbox'
import { Permission, RFIStatus } from 'shared'
import { useCheckPermission } from '../../../../../../../../../../../../../hooks/useCheckPermission'
import { useAuthContext } from '../../../../../../../../../../../../../context/AuthContext'
import CIMSBadge from '../../../../../../../../../../../../../components/CIMSBadge'

const ResponseDisciplines: React.FC<RequestForInformation> = ({
  id: rfiId,
  statusId,
  number,
  externalLinks,
  responseDisciplines,
  responses,
  deleted,
}) => {
  const { user } = useAuthContext()
  const {
    disciplineResponseModal: { toggle },
  } = useRFITrackerContext()
  const canRespondAll = useCheckPermission(
    Permission.RespondAllRFIResponseDisciplines
  )
  return (
    <Space size={'small'} direction="vertical" style={{ width: '100%' }}>
      {responseDisciplines.map(({ id, name, description, users }) => {
        const canRespond =
          canRespondAll || !!user?.implicitlyAuthorized({ users }).authorized
        const closedBy = responses.find(
          ({ closed, responseDisciplineId }) =>
            closed && responseDisciplineId === id
        )?.user
        const isClosed = !!closedBy
        const numResponses = responses.filter(
          ({ responseDisciplineId }) => responseDisciplineId === id
        ).length
        return (
          <Row
            key={`response-discipline-${rfiId}-${id}`}
            align="middle"
            justify="space-between"
          >
            <Col span={9}>
              <CIMSTag tooltip={description}>{name}</CIMSTag>
            </Col>
            {!!numResponses && (
              <Col span={7}>
                <CIMSBadge count={numResponses}>responses</CIMSBadge>
              </Col>
            )}
            <Col span={8} style={{ display: 'flex', justifyContent: 'end' }}>
              {statusId !== RFIStatus.Draft.id && (
                <>
                  {isClosed ? (
                    <CIMSCheckbox
                      checked
                      disabled={{
                        disabled: true,
                        reason: {
                          why: 'disabled',
                          message: `Closed by ${
                            closedBy.displayName ?? closedBy.mail
                          }`,
                        },
                      }}
                    />
                  ) : (
                    <Tooltip
                      title={
                        !canRespond
                          ? 'You do not have permission to submit a response'
                          : ''
                      }
                    >
                      <Button
                        type="link"
                        disabled={!canRespond || deleted}
                        style={{
                          whiteSpace: 'normal',
                          padding: 0,
                          margin: 0,
                        }}
                        onClick={() =>
                          toggle({
                            number,
                            requestForInformationId: rfiId,
                            responseDisciplineId: id,
                            externalLinks: externalLinks?.map(
                              ({ __typename, ...link }) => link
                            ),
                          })
                        }
                      >
                        Submit Response
                      </Button>
                    </Tooltip>
                  )}
                </>
              )}
            </Col>
          </Row>
        )
      })}
    </Space>
  )
}

export default ResponseDisciplines
